import { render, staticRenderFns } from "./BomSpecsContainer.vue?vue&type=template&id=e93ab602&"
import script from "./BomSpecsContainer.vue?vue&type=script&lang=js&"
export * from "./BomSpecsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports